import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fullDateShort, hourMinute } from '@showclix-shared-intl/dateTimeFormatters';
import { ISOStringToDate } from '../../../../helpers/time';
import KioskSeriesContainer from './KioskSeriesContainer';
import KioskSeriesHeaderContainer from './KioskSeriesHeaderContainer';
import KioskSeriesContentContainer from './KioskSeriesContentContainer';
import Translation from "../../../../shared/Translation";
import Spinner from "../../../../shared/Spinner";
import { TranslationContext } from '../../../../checkout/config/Translations';

// number of buttons on each page
const DEFAULT_PAGE_SIZE = 16;

class KioskSeriesTimes extends Component {

    state = {
        page: 1,
    };

    previousPage = () => {
        if (this.hasPreviousPage()) {
            this.setState({page: this.state.page - 1});
        }
    }

    nextPage = () => {
        if (this.hasNextPage()) {
            this.setState({page: this.state.page + 1});
        }
    }

    hasPreviousPage = () => {
        return this.state.page > 1;
    }

    hasNextPage = () => {
        return this.props.eventTimes.length - 1 > this.getPageEnd();
    }

    getPageStart = () => {
        return this.state.page === 1 ? 0 : ((this.state.page - 1) * this.pageSize());
    }

    getPageEnd = () => {
        return this.getPageStart() + this.pageSize() - 1;
    }

    pageSize = () => {
        return this.props.pageSize ?? DEFAULT_PAGE_SIZE
    }

    getButtons = () => {
        return (
          <TranslationContext.Consumer>
            {translation =>
              this.props.eventTimes.map((eventTime, i) => {

                if (i < this.getPageStart() || i > this.getPageEnd()) {
                    return null;
                }

                const salesOpen = ISOStringToDate(eventTime.salesOpen);
                const localeSaleDate = fullDateShort(this.props.locale, salesOpen);

                const salesTime = ISOStringToDate(eventTime.time);
                const saleTimeString = hourMinute(this.props.locale, salesTime);
                let selectedButton = parseFloat(eventTime.id);

                let soldOutMessage = eventTime.eventStatus === 'sold_out' ? this.props.getSoldOutMessage() : null;
                let lowInvMessage = eventTime.eventStatus === 'sold_out' ? null : this.props.getLowInventoryMessage(eventTime.inventory, translation);

                if(eventTime.eventStatus === 'sold_out' && this.props.showSoldOut === false) {
                    return null;
                }

                return (

                    <div className="event-time-button__container" key={i}>
                        <button
                            className={`button event-time-button event__times--fade
                            ${eventTime.eventStatus === 'sold_out' || eventTime.eventStatus === 'pre_sale' ? 'disabled' : 'selected'}`}
                            value={eventTime.id}
                            key={'btn_' + i}
                            onClick={eventTime.eventStatus === 'sold_out' || eventTime.eventStatus === 'pre_sale' ? () => false : this.props.onEventSelected}
                        >
                            {this.props.getEventTimeFormatted(eventTime.time, eventTime.endTime)}
                            {soldOutMessage && <div className="event-time-button__caption">{soldOutMessage}</div>}
                            {lowInvMessage && <div className="event-time-button__caption">{lowInvMessage}</div>}
                        </button>
                        {eventTime.eventStatus === 'pre_sale' && <div className="event-time-button__presale"> <Translation interpolation={{sale_date:localeSaleDate}}>{'checkout__kiosk_tickets_go_on_sale'}</Translation> </div>}
                    </div>
                )
              })
            }
          </TranslationContext.Consumer>
        );
    }

    render() {
        return (
            <KioskSeriesContainer>
                <KioskSeriesHeaderContainer>
                    <span>
                      <Translation interpolation={{selected_date:this.props.selectedDate}}>{'checkout__kiosk_all_times'}</Translation>
                    </span>
                    <div className="kiosk__series-picker__change-date">
                        <button className="button--link" onClick={this.props.onChangeDate}>
                            <i className="icon-calendar_today"  aria-hidden="true"></i>
                            <Translation>{'checkout__kiosk_change_date'}</Translation>
                        </button>
                    </div>
                </KioskSeriesHeaderContainer>
                {this.props.loading && <div className="kiosk__series_times_spinner">
                    <Spinner />
                </div>}
                {!this.props.loading && <KioskSeriesContentContainer>
                    <div className="event__times__group">
                        {this.getButtons()}
                    </div>
                </KioskSeriesContentContainer>}

                {(this.hasPreviousPage() || this.hasNextPage()) &&
                    <div className="kiosk__series-picker__pagination">
                        <div className="series-picker__pagination__item">
                            {this.hasPreviousPage() &&
                                <button className="series-picker__pagination__button button--link" onClick={this.previousPage}>
                                    <Translation>{'checkout__kiosk_prev_page'}</Translation>
                                    <i className="pagination-button__icon pagination-button__icon--prev icon-navigate_before" aria-hidden="true"></i>
                                </button>
                            }
                        </div>
                        <div className="series-picker__pagination__item">
                            {this.hasNextPage() &&
                                <button className="series-picker__pagination__button button--link" onClick={this.nextPage}>
                                  <Translation>{'checkout__kiosk_next_page'}</Translation>
                                  <i className="pagination-button__icon pagination-button__icon--next icon-navigate_next" aria-hidden="true"></i>
                                </button>
                            }
                        </div>
                    </div>
                }
            </KioskSeriesContainer>
        );
    }
}

KioskSeriesTimes.propTypes = {
    selectedDate: PropTypes.string,
    eventTimes: PropTypes.array,
    locale: PropTypes.string,
    getSoldOutMessage: PropTypes.func,
    getLowInventoryMessage: PropTypes.func,
    getEventTimeFormatted: PropTypes.func,
    onEventSelected: PropTypes.func.isRequired,
    onChangeDate: PropTypes.func.isRequired,
    showSoldOut: PropTypes.bool,
};

KioskSeriesTimes.defaultProps = {
    selectedDate: '',
    eventTimes: [],
    locale: 'en-US',
    getSoldOutMessage: () => '',
    getLowInventoryMessage: () => '',
    getEventTimeFormatted: () => '',
}

export default KioskSeriesTimes;
